import { render } from "./gif-pool.vue?vue&type=template&id=4c37226d&lang=pug"
import script from "./gif-pool.vue?vue&type=script&lang=js"
export * from "./gif-pool.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__